export default __webpack_public_path__ + "e2f1dd13f021a5250c119d260ac28a2c.svg";